
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNotification } from '../../context/NotificationContext';
import './Auth.css';

const API_URL = process.env.REACT_APP_API_URL;

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { showNotification } = useNotification();

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      const res = await fetch(`${API_URL}/api/users/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });

      const data = await res.json();

      if (!res.ok) {
        showNotification(
          data.error || 'Parola sıfırlama isteği başarısız!',
          'error'
        );
        return;
      }

      showNotification(
        'İşlem tamamlandı. E-posta kutunuzu ve spam klasörünüzü kontrol edin.',
        'success'
      );
    } catch (err) {
      console.error('Parola sıfırlama hatası:', err);
      showNotification('Sunucuya bağlanılamadı.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="auth-page auth-reset-page">
      <section className="auth auth-reset-card">
        <span className="auth-kicker">Hesap güvenliği</span>

        <h1>Parolanızı mı unuttunuz?</h1>

        <p className="auth-sub">
          Hesabınıza bağlı e-posta adresini girin.
          Parolanızı yenilemeniz için size bir bağlantı gönderelim.
        </p>

        <form className="auth-form" onSubmit={handleForgotPassword}>
          <label className="auth-field">
            <span className="auth-label">E-posta adresi</span>
            <input
              type="email"
              className="auth-input"
              placeholder="ornek@mail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </label>

          <button
            className="auth-button"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting
              ? 'Bağlantı gönderiliyor...'
              : 'Sıfırlama bağlantısı gönder'}
          </button>
        </form>

        <p className="auth-footer">
          Parolanızı hatırladınız mı?{' '}
          <Link to="/login">Giriş yap</Link>
        </p>
      </section>
    </main>
  );
}

export default ForgotPassword;
